



























































































































import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyCheckAmountKey from "@/components/company-check-amout-key";
import CompanyKey from "@/components/company-key";
import router from '../../../router';
export default createComponent({
  setup(props,context) {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyCheckAmount = inject(CompanyCheckAmountKey);
    if (!companyCheckAmount) {
      throw new Error(`${CompanyCheckAmountKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const inputMonth = (e:string) => {
      companyCheckAmount.inputMonth(e)
    }     
    const amountInfor = computed(() => companyCheckAmount.amountInfor);
    let month = '' as any
    const showMonth = context.root.$route.query.show_month
    if(showMonth){
      companyCheckAmount.setMonthValue(showMonth)
    }else {
      companyCheckAmount.setMonthValue(new Date().toISOString().substr(0, 7))
     }
    const getSettlementInfor = async(date: any) => {
      router.replace(`company_payment?show_month=${date}`,() => {})
      await companyCheckAmount.getSettlementInfor(date)
    }
    const companyName = computed(()=> company.companyInformation.companyInforList.company_name)
    const resetTableValue = companyCheckAmount.resetTableValue
    onMounted(() => {
      resetTableValue()
      company.getCompanyInfor()
      const paramsDate = context.root.$route.query.show_month
      if(paramsDate){
        companyCheckAmount.getSettlementInfor(paramsDate)
        companyCheckAmount.setMonthValue(paramsDate)
        month = paramsDate
      }else {
        companyCheckAmount.getSettlementInfor(new Date().toISOString().substr(0, 7))
        month = new Date().toISOString().substr(0, 7)
        companyCheckAmount.setMonthValue(new Date().toISOString().substr(0, 7))
      }
    });
    const formatNumber = (number: string) => displayui.formatNumber(number)
    const formatMonth = (month: string) => displayui.formatMonth(month)
    return {
      amountInfor,
      getSettlementInfor,
      companyName,
      month,
      formatNumber,
      formatMonth
    };
  },
})
